export default {
  name: "Navigation",
};



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js